import GenericDB from './generic-db';

export default class BillingDB extends GenericDB {
  constructor() {
    super('billing');
  }

  // Here you can extend BillingDB with custom methods
}
